import { IAppActionSetHierarchyValidationSaveBlocker, IUnifiedState } from "./interface";
import { createSingletonSaveBlockerSet } from "./saveBlockers/createSingletonSaveBlockerSet";

/**
 * Replaces the current validation blocker for a hierarchy property with the latest validation result.
 *
 * @param state - Current application save blockers.
 * @param action - Validation save-blocker action to apply.
 * @returns The updated save blockers.
 */
export const app_reduceValidationSaveBlockers = (
  state: IUnifiedState,
  action: IAppActionSetHierarchyValidationSaveBlocker,
): IUnifiedState => {
  const updatedBlockers = new Set(
    Array.from(state.saveBlockers).filter((blocker) => blocker.type !== action.propertyKey),
  );
  createSingletonSaveBlockerSet(action.propertyKey, action.warningText).forEach((blocker) =>
    updatedBlockers.add(blocker),
  );
  return {
    ...state,
    saveBlockers: updatedBlockers,
  };
};
